import { Const } from './provider/lib/const.cls';
import * as Types from '../../types';
import { mapActions } from 'vuex';
import { commonAll } from './lib/commonAll.cls';
import * as commonAllStoreExtensions from './provider/';
// import * as moment from 'moment'
import moment from 'moment-timezone';
const state = Object.assign({}, commonAllStoreExtensions.stateExt);
const actions = Object.assign({}, commonAllStoreExtensions.actionsExt);
const mutations = Object.assign({}, commonAllStoreExtensions.mutationsExt);
const getters = Object.assign({}, commonAllStoreExtensions.gettersExt);
// new store module definition
const commonAllStore = {
    state,
    actions,
    mutations,
    getters
};
// main mixin to load the new store module
export const commonAllmixins = {
    created() {
        const _store = this.$store;
        if (!(_store && _store.state && _store.state[commonAll.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(commonAll.STORE_MODULE_NAME, commonAllStore);
            }
            catch (error) { }
        }
    },
    methods: Object.assign(Object.assign({}, mapActions({
        _runGetProfileInfo: Const.RUN_GET_PROFILE_INFO,
        _runVerify2FaQrcode: Const.RUN_VERIFY_2FA_QRCODE,
        _runDisable2FaQrcode: Const.RUN_DISABLE_2FA_QRCODE,
        _runGetPaymentMethods: Const.RUN_GET_PAYMENT_METHODS,
        //===================trading Account=================
        _runTradingAccount: Const.RUN_TRADING_ACCOUNT,
        //=================== news data =================
        _runGetNewsData: Const.RUN_GET_NEWS_DATA,
        //============== ECONOMICCALENDER =================
        _runGetEconomicCalData: Const.RUN_GET_ECONOMIC_CALENDER_DATA,
        //=================== open Trade =================
        _runGetOpenTradeList: Const.RUN_GET_OPEN_TRADE,
        //=================== pending order =================
        _runGetpendingOrderList: Const.RUN_GET_PENDING_ORDER,
        //=================== Trade History ===================
        _runGetTradeHistoryList: Const.RUN_GET_TRADE_HISTORY,
        _runGetRemovedTradeList: Const.RUN_GET_REMOVED_TRADE_LIST,
        //================= Transaction History =================
        _runGetTransactionHistory: Const.RUN_GET_TRANSACTION_HISTORY,
        //=================== ACCOUNT BALANCE =================
        _runGetAccBalance: Const.RUN_GET_ACCOUNT_BALANCE,
        //=================== CURRENCY PAIRS =================
        _runGetCurrencyPairs: Const.RUN_GET_CURRENCY_PAIRS,
        _runGetpriceShift: Const.RUN_GET_PRICE_SHIFT,
        //===================== WATCH LIST ===================
        _runGetWatchList: Const.RUN_GET_WATCH_LIST,
        _runCreateWatchList: Const.RUN_CREATE_WATCH_LIST,
        _runUpdateWatchList: Const.RUN_UPDATE_WATCH_LIST,
        _runDeleteWatchList: Const.RUN_DELETE_WATCH_LIST,
        //====================== 2FA API ==================
        _runGenerate2FaQrcode: Const.RUN_GENERATE_2FA_QRCODE,
        //=================== ACCOUNT REPORTS =================
        _runGetAccountReport: Const.RUN_GET_ACCOUNT_REPORTS,
        //==================== Provider List ==================
        _runGetProviderList: Const.RUN_GET_PROVIDER_LIST,
        //==================== USER ACCOUNTS ==================
        _runGetUserAccount: Const.RUN_GET_USER_ACCOUNTS,
        _runCreateDemoAcc: Const.RUN_CREATE_DEMO_ACC,
        //==================== USER ACCOUNTS ==================
        _runSetUserSettings: Const.RUN_SET_USER_SETTINGS,
        _runGetUserSettings: Const.RUN_GET_USER_SETTINGS,
        //==================== Price alert ==================
        _runGetActivePriceAlert: Const.RUN_GET_ACTIVE_PRICE_ALERT,
        _runGetTriggeredPriceAlert: Const.RUN_GET_TRIGGERED_PRICE_ALERT,
        //==================== PORTFOLIO ==================
        _runGetPortfoliosData: Const.RUN_GET_PORTFOLIO,
        _runGetChartData: Const.RUN_GET_CHART_DATA,
        //==================== GET RAW OBJECT ==================
        _runGetRawObject: Const.RUN_GET_RAW_OBJECT,
        _runSetRawObject: Const.RUN_SET_RAW_OBJECT,
        //==================== TECHNICAL ANALYSIS ==================
        _runGetTechnicalAnalysis: Const.RUN_GET_TECHNICAL_ANALYSIS,
        //==================== PIVOT DATA ==================
        _runGetPivotData: Const.RUN_GET_PIVOT_DATA,
        //==================== CHART DATA ==================
        _rungetChartData: Const.RUN_GET_TV_CHART_DATA,
        //==================== COPYTRADING ==================
        _runGetLeadersList: Const.RUN_GET_LEADERS_LIST,
        _runGetLeadersDetail: Const.RUN_GET_LEADER_DETAIL,
        _runGetProfitChartData: Const.RUN_GET_PROFIT_CHART_DATA,
        _runGetDrawdownChartData: Const.RUN_GET_DRAWDOWN_CHART_DATA,
        _runGetPerformanceChartData: Const.RUN_GET_PERFORMANCE_CHART_DATA,
        _runGetPortfolioChartData: Const.RUN_GET_PORTFOLIO_CHART_DATA,
        _runGetLeaderTradeHistory: Const.RUN_GET_LEADER_TRADE_HISTORY,
        _runGetAllLeadersList: Const.RUN_GET_ALL_LEADERS_LIST,
        _runGetFollowersSetting: Const.RUN_GET_FOLLOWERS_SETTING,
        _runFollowTrade: Const.RUN_FOLLOW_TRADE,
        _runGetUserEquityChartWithLeader: Const.RUN_GET_USER_EQUITY_CHART_WITH_LEADER,
        _runGetCopytradingToken: Const.RUN_GET_USER_COPYTRADING_TOKEN,
    })), { pageName(val) {
            this.$parent.pageTxt = val;
        },
        computedCommonFunc(getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        },
        isFollowing(providerId) {
            return (this.followersSetting.providers || []).find(v => v.providerId == providerId && v.zuluAccountId && this.userCopytradingDetails.zulu.zulu_account_id);
        },
        formatDateTime(value) {
            if (this.userSettings.timezone && this.userSettings.timezone == '1') {
                return moment(value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSSS').format('HH:mm:ss - DD-MM-YYYY');
            }
            else {
                // return moment(value).format('HH:mm:ss - DD-MM-YYYY');
                return moment.tz(value, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSSS', 'America/New_York').local().format("HH:mm:ss - DD-MM-YYYY");
            }
        },
        formatDate(value) {
            return moment(value).local().format('DD MMM YYYY, h:mm:ss a');
        },
        numberFormating(value) {
            value = Number(value);
            if (value) {
                return value.toLocaleString();
            }
            else {
                return 0;
            }
        },
        divide9(num) {
            return Number(num) / 9;
        },
        multiply9(num) {
            return Number(num) * 9;
        },
        getNumberWithSign(number) {
            if (number > 0) {
                return `+${Number(number).toFixed(2)}`; // Return the number with a '+' sign for positive numbers
            }
            return number.toFixed(2); // Return the number as-is for zero or negative numbers
        },
        numberFormat(value) {
            if (value) {
                var data = value;
                console.log(data);
                if (!isNaN(value) && value.toString().indexOf('.') != -1) {
                    // console.log('length',data.toString().split(".")[1],data.toString().split(".")[1].length)
                    data = parseFloat(value).toFixed(8);
                }
                // data = parseFloat(value).toFixed(8)
                return data.toString().replace('/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g', ",");
            }
            else {
                return '';
            }
        },
        formatCurrency(value, currency) {
            if (currency == undefined)
                return Math.abs(value).toFixed(2);
            else if (currency === 'BTC') {
                // Custom formatting for BTC
                return `${value < 0 ? '-' : ''}₿${Math.abs(value).toFixed(8)}`;
            }
            else {
                // Formatting for standard currencies
                const options = { style: 'currency', currency: currency };
                return new Intl.NumberFormat('en-US', options).format(value || 0);
            }
        },
        changeTick(name, type, varName) {
            if (type == 1) {
                this.$refs[name].stepUp();
                this[varName] = this.$refs[name].value;
                if (this['change_' + varName])
                    this['change_' + varName](this.$refs[name].value);
                // console.log(this.$refs, type,varName, 'hiiiiiiiiiiiiiiiiiiiiiii')
            }
            else if (type == 0) {
                if (['price', 'stop', 'limit'].includes(varName) && (this[varName] == '' || parseFloat(this[varName]) == 0)) {
                    this[varName] = this.instruments[this.currency_pair].A;
                    if (this['change_' + varName])
                        this['change_' + varName](this[varName]);
                }
                else {
                    this.$refs[name].stepDown();
                    this[varName] = this.$refs[name].value;
                    if (this['change_' + varName])
                        this['change_' + varName](this.$refs[name].value);
                }
            }
            /*if(type == 1){
                console.log('buy',parseFloat(this[name]) + parseFloat(steps))
                this[name] = parseFloat(parseFloat(this[name]) + parseFloat(steps))
                }else if(type == 0){
                console.log('Sell',parseFloat(this[name]) - parseFloat(steps))
                if((parseFloat(this[name]) - parseFloat(steps)) <= 0){
                    this[name] = 0
                }else{
                   this[name] = parseFloat(this[name]) - parseFloat(steps)
                }
            }*/
        },
        keyUp(e, varName) {
            if (['price', 'stop', 'limit'].includes(varName) && parseFloat(this[varName]) == 0 && e.key == 'ArrowDown') {
                this[varName] = this.instruments[this.currency_pair].A;
            }
            else if (this['change_' + varName]) {
                this['change_' + varName](this[varName]);
            }
        },
        getRawData() {
            let data = this.rawObject;
            // let data = {}
            if (!data.view_mode) {
                data['view_mode'] = { page: 'custom-view', workSpace: [] };
            }
            if (!data.view_mode.workSpace) {
                data.view_mode['workSpace'] = [];
            }
            if (!data.view_mode.chart_layout) {
                data.view_mode['chart_layout'] = [];
            }
            return data;
        } }),
    computed: {
        showChart() {
            // true for ChartIQ and false for trading view
            if (process.env.product == 'coinexx') {
                // console.log('----------------1');
                return true;
            }
            else if (process.env.product == 'Hanko') {
                // console.log('----------------2',this.appChart);
                // return this.appChart;
                // return ['54275125','T260630','T303164','act_test2','T196577','T304528','T259292','54275202'].includes((this.get_user.username || '').split('$$')[1])
                return true;
            }
            else if (process.env.product == 'act') {
                return !['T196051'].includes((this.get_user.username || '').split('$$')[1]);
                // return true;
            }
            else {
                // console.log('----------------3');
                return true;
            }
        },
        followersSetting: function () { return this.computedCommonFunc(Const.GET_FOLLOWERS_SETTING); },
        leadersList: function () { return this.computedCommonFunc(Const.GET_LEADERS_LIST); },
        allLeadersList: function () { return this.computedCommonFunc(Const.GET_ALL_LEADERS_LIST); },
        leaderDetail: function () { return this.computedCommonFunc(Const.GET_LEADER_DETAIL); },
        leadersFilter: function () { return this.computedCommonFunc(Const.GET_LEADER_FILTES); },
        pivotData: function () { return this.computedCommonFunc(Const.GET_PIVOT_DATA); },
        technicalAnalysis: function () { return this.computedCommonFunc(Const.GET_TECHNICAL_ANALYSIS); },
        appTheme: function () { return this.computedCommonFunc(Const.GET_APP_THEME); },
        appChart: function () { return this.computedCommonFunc(Const.GET_APP_CHART); },
        defaultWorkSpaceList: function () { return this.computedCommonFunc(Const.GET_DEFAULT_WORKSPACE_LIST); },
        rawObject: function () { return this.computedCommonFunc(Const.GET_RAW_OBJECT); },
        portfolioData: function () { return this.computedCommonFunc(Const.GET_PORTFOLIO); },
        activePriceAlert: function () { return this.computedCommonFunc(Const.GET_ACTIVE_PRICE_ALERT); },
        triggeredPriceAlert: function () { return this.computedCommonFunc(Const.GET_TRIGGERED_PRICE_ALERT); },
        priceAlertNotification: function () { return this.computedCommonFunc(Const.GET_PRICE_ALERT_NOTIFICATON); },
        userSettings: function () { return this.computedCommonFunc(Const.GET_USER_SETTINGS); },
        wsStatus: function () { return this.computedCommonFunc(Const.GET_WS_STATUS); },
        accountList: function () { return this.computedCommonFunc(Const.GET_USER_ACCOUNTS); },
        profileData: function () { return this.computedCommonFunc(Const.GET_USER_PROFILE); },
        providerList: function () { return this.computedCommonFunc(Const.GET_PROVIDER_LIST); },
        orderBook: function () { return this.computedCommonFunc(Const.GET_ORDER_BOOK); },
        watchListData: function () { return this.computedCommonFunc(Const.GET_WATCH_LIST); },
        currencyPairs: function () { return this.computedCommonFunc(Const.GET_CURRENCY_PAIRS); },
        priceShift: function () { return this.computedCommonFunc(Const.GET_PRICE_SHIFT); },
        wsOrder: function () { return this.computedCommonFunc(Const.GET_WS_ORDER); },
        rejectedTradeList: function () { return this.computedCommonFunc(Const.GET_REJECTED_TRADE); },
        pendingTradeList: function () { return this.computedCommonFunc(Const.GET_PENDING_TRADE); },
        accBalance: function () { return this.computedCommonFunc(Const.GET_ACCOUNT_BALANCE); },
        transactionHistory: function () { return this.computedCommonFunc(Const.GET_TRANSACTION_HISTORY); },
        openTradeList: function () { return this.computedCommonFunc(Const.GET_OPEN_TRADE); },
        pendingOrderList: function () { return this.computedCommonFunc(Const.GET_PENDING_ORDER); },
        tradeHistoryList: function () { return this.computedCommonFunc(Const.GET_TRADE_HISTORY); },
        newsData: function () { return this.computedCommonFunc(Const.GET_NEWS_DATA); },
        economicCalData: function () { return this.computedCommonFunc(Const.GET_ECONOMIC_CALENDER_DATA); },
        get_user: function () { return this.computedCommonFunc(Types.GET_USER); },
        profileInfo: function () { return this.computedCommonFunc(Const.GET_PROFILE_INFO); },
        GetPaymentMethods: function () { return this.computedCommonFunc(Const.GET_PAYMENT_METHODS); },
        tradingAccount: function () { return this.computedCommonFunc(Const.GET_TRADING_ACCOUNT); },
        configProvider: function () { return this.computedCommonFunc(Const.GET_REGISTER_PROVIDERS); },
        profitChartData: function () { return this.computedCommonFunc(Const.GET_PROFIT_CHART_DATA); },
        performanceChartData: function () { return this.computedCommonFunc(Const.GET_PERFORMANCE_CHART_DATA); },
        portfolioChartData: function () { return this.computedCommonFunc(Const.GET_PORTFOLIO_CHART_DATA); },
        drawdownChartData: function () { return this.computedCommonFunc(Const.GET_DRAWDOWN_CHART_DATA); },
        leaderTradeHistory: function () { return this.computedCommonFunc(Const.GET_LEADER_TRADE_HISTORY); },
        userEquityChartWithLeader: function () { return this.computedCommonFunc(Const.GET_USER_EQUITY_CHART_WITH_LEADER); },
        userCopytradingDetails: function () { return this.computedCommonFunc(Const.GET_USER_COPYTRADING_TOKEN); },
    }
};
export default commonAllmixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/commonAll/index.ts
// module id = null
// module chunks = 